var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dataIsObject, NODE_ENV, REACT_APP__URL_EASYPOST_BASE, REACT_APP__URL_SMP_API, } from "@smp/utils";
import { apiTokenJwtUpdate, apiTokens, encodeQueryString, getHeaders, } from "./api.static";
import { failureApiGenerator, } from "./failure";
export function apiRequest(requestParams, errorToFailureHash = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { body, credentials, endpoint, redirectToLoginOnForbidden = false, headers, method, next, query = {}, repeat = true, responseType, signal, } = requestParams;
        let response;
        try {
            const url = next || (query ? `${endpoint}${encodeQueryString(query)}` : endpoint);
            response = yield fetch(url, {
                body: dataIsObject(body) ? JSON.stringify(body) : body,
                credentials: credentials ||
                    (endpoint.includes(REACT_APP__URL_EASYPOST_BASE)
                        ? "include"
                        : "same-origin"),
                headers: getHeaders(endpoint, headers, body),
                method,
                mode: "cors",
                signal,
            });
        }
        catch (clause) {
            const error = clause;
            throw failureApiGenerator({
                body: {
                    error_type: error.name === "AbortError" ? "ABORT_ERROR" : "FETCH_INTERNAL",
                    message: error.message ? error.message : error.toString(),
                    name: error.name,
                },
                response: new Response(),
            }, errorToFailureHash);
        }
        apiTokens.csrf =
            (typeof document !== "undefined" &&
                ((_a = document.cookie
                    .split(";")
                    .find((item) => item.includes("csrftoken"))) === null || _a === void 0 ? void 0 : _a.split("=")[1])) ||
                apiTokens.csrf;
        apiTokens.smp = response.headers.get("X-SMP-JWT") || apiTokens.smp;
        if (response.headers.get("X-DEPRECATED")) {
            console.warn("Deprecated endpoint: ", endpoint);
        }
        const contentType = response.headers.get("Content-Type");
        const responseBody = responseType
            ? yield response[responseType]()
            : (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json"))
                ? yield response.json()
                : contentType === "text/html"
                    ? yield response.text()
                    : response;
        if (response.status >= 400) {
            if (repeat &&
                endpoint.includes(REACT_APP__URL_SMP_API) &&
                (response.status === 403 || response.status === 401)) {
                yield apiTokenJwtUpdate();
                return apiRequest(Object.assign(Object.assign({}, requestParams), { redirectToLoginOnForbidden, repeat: false }), errorToFailureHash);
            }
            else {
                const { location, location: { pathname, search }, } = window;
                if ((response.status === 403 || response.status === 401) &&
                    redirectToLoginOnForbidden &&
                    !pathname.includes("/home/auth")) {
                    const next = encodeURIComponent(`${pathname}${search || ""}`);
                    location.href = `/home/auth/signin?next=${next}`;
                    return responseBody;
                }
                else {
                    throw failureApiGenerator({
                        body: responseBody,
                        response,
                    }, errorToFailureHash);
                }
            }
        }
        else {
            return responseBody;
        }
    });
}
export const apiRecursive = (fn, args, next = null, resultsPrevious, limit = 10) => __awaiter(void 0, void 0, void 0, function* () {
    let results = resultsPrevious || [];
    const [req, argsOptional] = args;
    if (NODE_ENV === "development" && next) {
        next = next.replace("https://staging.smmplanner.com/", REACT_APP__URL_EASYPOST_BASE);
    }
    const response = yield fn(next ? Object.assign(Object.assign({}, req), { next }) : req, argsOptional);
    results = [...results, ...response.results];
    if (response.next) {
        return yield apiRecursive(fn, args, response.next, results, limit);
    }
    else {
        return results;
    }
});
//# sourceMappingURL=api.js.map